import { buildModelManager } from "../builder.js";
const DefaultQuoteAttachmentSelection = {
  __typename: true,
  id: true,
  caption: true,
  createdAt: true,
  deletedAt: true,
  file: { url: true, mimeType: true, fileName: true },
  profileId: true,
  updatedAt: true,
  uploadedAt: true,
  uploadedByUserId: true,
  workItemId: true
};
const modelApiIdentifier = "quoteAttachment";
const pluralModelApiIdentifier = "quoteAttachments";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuoteAttachmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuoteAttachmentSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuoteAttachmentSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuoteAttachmentSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuoteAttachmentSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuoteAttachmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuoteAttachmentSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createQuoteAttachment",
    operationReturnType: "CreateQuoteAttachment",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      quoteAttachment: { required: false, type: "CreateQuoteAttachmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "action",
    operationName: "bulkCreateQuoteAttachments",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateQuoteAttachmentsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "action",
    operationName: "updateQuoteAttachment",
    operationReturnType: "UpdateQuoteAttachment",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      quoteAttachment: { required: false, type: "UpdateQuoteAttachmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateQuoteAttachments",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateQuoteAttachmentsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "action",
    operationName: "deleteQuoteAttachment",
    operationReturnType: "DeleteQuoteAttachment",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteQuoteAttachments",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreQuoteAttachment",
    operationReturnType: "RestoreQuoteAttachment",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      quoteAttachment: { required: false, type: "RestoreQuoteAttachmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreQuoteAttachments",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestoreQuoteAttachmentsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "action",
    operationName: "upsertQuoteAttachment",
    operationReturnType: "UpsertQuoteAttachment",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      quoteAttachment: { required: false, type: "UpsertQuoteAttachmentInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateQuoteAttachmentResult": { hasReturnType: false },
      "... on UpdateQuoteAttachmentResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertQuoteAttachments",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertQuoteAttachmentsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultQuoteAttachmentSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "quoteAttachmentGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QuoteAttachmentManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQuoteAttachmentSelection,
  operations
);
export {
  DefaultQuoteAttachmentSelection,
  QuoteAttachmentManager
};
//# sourceMappingURL=QuoteAttachment.js.map
